let epIdWithPaymentStatus = function(epId, isPaid) {
  //not paid
  if (isPaid == null) {
    return epId
  }
  return `${isPaid}${epId}`
}

export { epIdWithPaymentStatus }
